<section class="login-page">
    <div class="container-fluid">
        <div class="row">
            
            <!--- Welcome image  --->
            <div class="col-md-6 col-lg-6 col-xl-6 col-xxl-5">
                <div class="login-image">
                    <img src="assets/images/logo-white.png" alt="logo">
                    <div class="login-content">
                        <h2>Welcome to QCAM</h2>
                        <p>QMigrator is an AI based tool for migrating on-prem or cloud databases such as Oracle, SQL Server, DB2 to Open-source databases like PostgreSQL, MySQL or MariaDB in any cloud. Below are the top features of QMigrator to help you migrate your databases quickly.</p>
                    </div>
                    <div class="login-footer">
                        <ul>
                            <li><a href="https://qmigrator.ai" target="_blank">Marketplace</a></li>
                            <li><a href="#">License</a></li>
                            <li><a href="#">Terms of Use</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-lg-6 col-xl-6 col-xxl-7">
                <div class="login-form">
                    <div class="login-from-content">
                        <div class="login-logo">
                            <img src="assets/images/logo.png" alt="logo" class="d-block m-auto" />
                        </div>
                        <h2>Sign in to QMigrator Admin</h2>
                        <p>Create, Modify and Delete Project/User</p>

                        <!--- Login Form  --->
                        <form class="form qmig-Form" [formGroup]="loginForm" (ngSubmit)="onSubmit(loginForm.value)">
                            <div class="form-group">
                                <i class="mdi mdi-at"></i>
                                <input type="text" class="form-control" placeholder="user@example.com" formControlName="emailID" />
                                <span class="mdi mdi-close" (click)="resetUser()"></span>
                                @if ( f.emailID.touched && f.emailID.invalid) {
                                    <p class="text-start text-danger mt-1">
                                        @if (f.emailID.errors.required) { Email is required }
                                        @if (f.emailID.errors.email) { Please enter valid email. }
                                    </p>                                    
                                }                            
                            </div>
                            <div class="form-group">
                                <i class="mdi mdi-lock-outline"></i>
                                <input type="password" class="form-control" placeholder="Password" formControlName="password" />
                                <span class="mdi mdi-close" (click)="resetPassword()"></span>
                                @if ( f.password.touched && f.password.invalid) {
                                    <p class="text-start text-danger mt-1">
                                        @if (f.password.errors.required) { Password is required }
                                        @if (f.password.errors.minlength) { Minimum length should be 3 letters required. }
                                    </p>                                    
                                } 
                            </div>
                            <div>
                                <button class="btn btn-sign w-100 " [disabled]="loginForm.invalid"> Sign In @if(spinner){<app-spinner-white/>} </button>
                            </div>
                            <p class="mt-3"><a href="javascript:void(0)" routerLink="/resetPassword"> Forgot Password ? </a> </p>
                        </form>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>